import { render } from "./MockupCatalogs1.vue?vue&type=template&id=46795369&scoped=true&ts=true&lang=pug"
import script from "./MockupCatalogs1.vue?vue&type=script&lang=ts"
export * from "./MockupCatalogs1.vue?vue&type=script&lang=ts"

import "./MockupCatalogs1.vue?vue&type=style&index=0&id=46795369&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46795369"]])

export default __exports__